import React from 'react';
import './StrategyRowCard.css';

const formatCurrency = (n, contractType = 'NQ', strategyName = '', contractSize = 1) => {
  let num = Number(n) || 0;
  // Multiply by contract size first
  num = num * contractSize;
  // Convert to MNQ if needed (divide by 10), but skip if strategy name contains "micro"
  const isMicroStrategy = strategyName.toLowerCase().includes('micro');
  if (contractType === 'MNQ' && !isMicroStrategy) {
    num = num / 10;
  }
  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);
  // For MNQ (non-micro strategies), show 2 decimal places; for NQ or micro strategies, show whole numbers
  const shouldShowDecimals = contractType === 'MNQ' && !isMicroStrategy;
  const formatted = shouldShowDecimals
    ? abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : abs.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return `${sign}$${formatted}`;
};

const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

function StrategyRowCard({ strategy, category, contractType = 'NQ', contractSize = 1, onStrategyClick }) {
  const weeklyTotal = strategy.weeklyTotal || 0;
  const status = weeklyTotal > 0 ? 'WIN' : weeklyTotal < 0 ? 'LOSS' : 'FLAT';

  return (
    <div className="strategy-card">
      <div className="strategy-card-top">
        <div className="left">
          <button
            type="button"
            className="strategy-name-button"
            onClick={() => onStrategyClick && onStrategyClick(strategy.strategyName)}
          >
            <span className="strategy-name">{strategy.strategyName}</span>
          </button>
          {category && <span className="category-pill">{category}</span>}
          <span className={`badge ${status.toLowerCase()}`}>{status}</span>
        </div>
        <div className="right">
          <span className={`weekly ${weeklyTotal >= 0 ? 'pos' : 'neg'}`}>{formatCurrency(weeklyTotal, contractType, strategy.strategyName, contractSize)}</span>
        </div>
      </div>

      <div className="day-chips">
        {dayOrder.map((d) => {
          const val = strategy.dailyPnL?.[d] ?? 0;
          const tone = val > 0 ? 'pos' : val < 0 ? 'neg' : 'flat';
          return (
            <span key={d} className={`day-chip ${tone}`} title={`${d}: ${formatCurrency(val, contractType, strategy.strategyName, contractSize)}`}>
              {d.slice(0, 3)} {val !== 0 ? formatCurrency(val, contractType, strategy.strategyName, contractSize) : ''}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default StrategyRowCard;

